/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AsCodeMonitorParamsDto = {
    kind?: AsCodeMonitorParamsDto.kind;
};

export namespace AsCodeMonitorParamsDto {

    export enum kind {
        METRICS = 'Metrics',
        FRESHNESS = 'Freshness',
        ROW_DUPLICATES = 'RowDuplicates',
        FIELD_UNIQUENESS = 'FieldUniqueness',
        SCHEMA_CHANGE = 'SchemaChange',
        SQL = 'Sql',
        CONDITIONAL = 'Conditional',
        SQL_CONDITION = 'SqlCondition',
        CORRELATED_METRICS = 'CorrelatedMetrics',
        DISTRIBUTION = 'Distribution',
        CUSTOM_METRICS = 'CustomMetrics',
        FIELD_FORMAT = 'FieldFormat',
        FIELD_IN_LIST = 'FieldInList',
        METADATA_FRESHNESS = 'MetadataFreshness',
        REFERENTIAL_INTEGRITY = 'ReferentialIntegrity',
        VOLUME = 'Volume',
        VALUE_RANGE = 'ValueRange',
        FIELD_DUPLICATES = 'FieldDuplicates',
        FIELD_NULLS = 'FieldNulls',
        STATIC_FIELD_PROFILING = 'StaticFieldProfiling',
        DYNAMIC_FIELD_PROFILING = 'DynamicFieldProfiling',
        STATIC_METRICS = 'StaticMetrics',
        DYNAMIC_METRICS = 'DynamicMetrics',
        COMPLETENESS = 'Completeness',
        STATIC_COMPLETENESS = 'StaticCompleteness',
        DUPLICATES = 'Duplicates',
    }


}
